<template>
    <div class="container section">
        <div class="row heading">
            <div class="col-6">
                <h2>Carrier Emails</h2>
            </div>
            <div class="col-6 text-right">
                <button class="btn btn-primary" @click="editEmails">Create Email</button>
            </div>

        </div>
        <div class="row" v-for="email in carrierEmails">
            <div class="col-4 col-form-label">
                <label>{{email.name}}</label>
            </div>
            <div class="col-6 email-preview" v-html="email.content">
            </div>
            <div class="col-2 text-right">
                <button class="btn btn-secondary" @click="editEmails(email)">Edit Email</button>
            </div>
        </div>

        <modal v-if="showEditEmail" size="lg" allow-click-away="false" >
            <div slot="header">
                <h3>Edit Carrier Email</h3>
                <button type="button" class="btn btn-clear close-btn"  @click="cancelEdit">
                    <i class="fa fa-remove" />
                </button>
            </div>

            <editor slot="body" :selected="selected" @saveEmail="saveEmail" style="width: 600px; margin: 0 auto;"></editor>

        </modal>


    </div>
</template>
<script type="text/babel">

    import Modal from '../assets/Modal.vue';
    import Editor from './Editor.vue';


    export default {
        name: 'carrierEmails',
        data: function () {
            return {
                carrierEmails: [],
                editing: false,
                showEditEmail: false,
                selected: {
                    name: '',
                    content: ''
                },
                editor: null,
                table: null,
                showTableOptions: false,
                selectedEmail: {}
            }
        },
        components:{
            Modal,
            Editor
        },
        mounted(){


        },
        created(){
            this.fetchData();
        },
        props: ['carrier_id'],
        methods: {
            fetchData(){
                this.$send(this, 'carrierEmails', {
                    carrier_id: this.carrier_id
                }).then(r => {
                    this.carrierEmails = r.carrierEmails;
                });

            },
            save(){

                var data = JSON.parse(JSON.stringify(this.selected));
                data.carrier_id = this.carrier_id;

                this.$send(this, 'carrierUpdate', data).then(r => {
                    this.fetchData();
                    this.cancel();
                });

            },
            cancel(){
                this.editing = null;
                this.selected = {};
                this.editor.destroy()
            },
            editEmails(email){

                this.selected = email || {};
                this.showEditEmail = true;
            },
            cancelEdit(){
                this.selected = {
                    name: '',
                    content: '',
                };
                this.showEditEmail = false;


            },
            saveEmail(content){



                this.$send(this, 'carrierEmailUpdate', content).then(r => {
                    this.fetchData();
                    this.showEditEmail = false;
                });
            }
        },

    }

</script>

<style>
    #editor{
        border: 1px solid #e2e2e2;
        width: 600px;
        margin: 0 auto;
    }

    .ql-editor table {
        border-spacing: 0;
        border: 1px solid #e2e2e2;
        width: 100%;
    }

    .ql-editor tr {
        border-bottom: 1px solid #e2e2e2;

    }

    .ql-editor tr:last-child{
        border-bottom: none;

    }
    .ql-editor td {
        border-right: 1px solid #e2e2e2;
        margin: 0;
        border-spacing: 0;
        padding: 0;
    }
    .ql-editor td > span{
        display: block;
        padding: 5px;
    }
    .ql-editor td:last-child{
        border-right: none;

    }
    #table-options{
        position: relative;
        display: inline-block;
    }
    .table-option-list{
        position: absolute;
        top: 20px;
        width: 200px;
        left: 0;
        background-color: white;
        z-index:5000;
        border: 1px solid #e2e2e2;
    }
    .table-option-list div{
        display: block;
        width: 100%;
        padding: 5px 8px;

    }
    .table-option-list div:hover{
        background: #f0f0f0;
    }

    .line-dotted {
        border-style: dotted;
    }
    .line-solid {
        border-style: solid;
    }
    .line-double {
        border-style: double;
    }

    .email-preview{
        max-height: 300px;
        overflow: hidden;
        border: 1px solid #e2e2e2;
        box-shadow: 4px 4px 4px #cccccc;
        margin-bottom: 30px;
    }

    .email-preview table{
        border: none;
        table-layout: fixed
    }



</style>


// WEBPACK FOOTER //
// CarrierEmails.vue?46edb18c